import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { type LegacyUser as User } from '../../app/ApiGen';
import { AuthenticatedUserState } from './types';

const initialState: AuthenticatedUserState = {
  loading: false,
  mfaRequired: false,
  error: undefined,
  current: undefined,
};

const authenticatedUserSlice = createSlice({
  name: 'authenticatedUserSlice',
  initialState,
  reducers: {
    getAuthenticatedUserAction: (state: AuthenticatedUserState): AuthenticatedUserState => ({
      ...state,
      loading: true,
      error: undefined,
    }),
    setAuthenticatedUserAction: (
      state: AuthenticatedUserState,
      action: PayloadAction<{ user: User }>,
    ): AuthenticatedUserState => ({
      ...state,
      loading: false,
      error: undefined,
      current: action.payload.user,
    }),
    setAuthenticatedUserErrorAction: (
      state: AuthenticatedUserState,
      action: PayloadAction<{ error: Error }>,
    ): AuthenticatedUserState => ({
      ...state,
      loading: false,
      error: action.payload.error,
    }),
    clearAuthenticatedUserAction: (state: AuthenticatedUserState): AuthenticatedUserState => ({
      ...state,
      loading: true,
      error: undefined,
    }),
    clearAuthenticatedUserDoneAction: (state: AuthenticatedUserState): AuthenticatedUserState => ({
      ...state,
      loading: false,
      error: undefined,
      current: undefined,
    }),
    setAuthenticatedUserNeedsMfaAction: (state: AuthenticatedUserState): AuthenticatedUserState => ({
      ...state,
      mfaRequired: true,
    }),
    clearAuthenticatedUserNeedsMfaAction: (state: AuthenticatedUserState): AuthenticatedUserState => ({
      ...state,
      mfaRequired: false,
    }),
  },
});

export const { actions: authenticatedUserActions, reducer: authenticatedUserReducers } = authenticatedUserSlice;
